<template>
    <div class="bindChildren">
        <div class="top" v-if="imei">
            <img src="@/assets/img/peo3.png" class="imgs"><p class='font16'>宝贝</p>
        </div>
        <div class="con">
           <!-- <van-field name="uploader" label="头像" input-align="right">
                <template #input>
                    <upload-img uplogType='4' ref='uploadImg' @active='getImg' :imgs='studentAvatar'></upload-img>
                </template>
           </van-field> -->
           <van-field v-model="studentName" label="宝贝姓名" placeholder="" input-align="right" @click="optInput('studentName','宝贝姓名')" right-icon="arrow" readonly/>
           <van-field v-model="sex" label="性别" placeholder="" input-align="right" @click="operate('sex')" right-icon="arrow" readonly />
           <van-field v-model="kinshipName" label="亲属关系" placeholder="" input-align="right" @click="operate('kinshipName')" right-icon="arrow" readonly/>
           <van-field v-model="birthday" label="出生日期" placeholder="" input-align="right" @click="operate('birthday')" right-icon="arrow" readonly/>
           <van-field v-model="height" label="身高" placeholder="" input-align="right" @click="optInput('height','身高')" right-icon="arrow" readonly/>
           <van-field v-model="weight" label="体重" placeholder="" input-align="right" @click="optInput('weight','体重')" right-icon="arrow" readonly/>
        </div>
        <div class="con" style="margin-bottom:.26rem" v-if="details">
            <van-field label="学校" input-align="right">
                <template #input>
                    {{details.schoolName}}
                </template>
           </van-field>
           <template v-if="isChange">
            <van-field v-model="details.gradeName" label="年级" placeholder="" input-align="right" @click="optGrade('gradeName')" right-icon="arrow" readonly />
            <van-field v-model="details.className" label="班级" placeholder="" input-align="right" @click="optGrade('className')" right-icon="arrow" readonly />
           </template>
           <template v-else>
           <van-field label="年级" input-align="right">
                <template #input>
                    {{details.gradeName}}
                </template>
           </van-field>
           <van-field label="班级" input-align="right">
                <template #input>
                    {{details.className}}
                </template>
           </van-field>
           </template>
        </div>
        <template>
           <div class="btn-primary " @click='handleClick'>保存</div>
           <div class='delect font18' v-if="studentId&&channelCode=='esi'" @click="delectCon">删除</div>
        </template>

        <!--设置-->
        <van-action-sheet v-model="isSet" :lazy-render='false'>
            <van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :maxDate='maxDate' title="选择年月日" v-if="key=='birthday'" @confirm='confirm' @cancel='isSet=false'/>
            <van-picker ref = "picker" show-toolbar :title='title'  :columns="columns" @confirm='confirm' @cancel='isSet=false' v-else/>
        </van-action-sheet>
        
        <van-popup v-model="isInput" class="textPopup">
            <div class="inputCon">
                    <p class="title font18">{{title}}</p>
                    <div  class="inputs flex-between">
                        <input v-model="curText" placeholder=""  maxlength='6'>
                        <span v-if="key=='height'">CM</span>
                        <span v-if="key=='weight'">KG</span>
                    </div>
                    <div class='btn font16'>
                        <p @click="hide">取消</p>
                        <p @click="saveText">确定</p>
                    </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
   import {getStudentInfo,bindingChild,deleteStudent,updateChild,switchUserIdentity} from '@/api/api.mine.js';
   import {getGradeClassList} from "@/api/api.common";
   import {getKinshipList} from "@/api/api.equipment";
    import uploadImg from '@/components/uploadImg.vue';
    export default {
        data() {
            return {
                imei:this.$route.query.imei,
                studentId:this.$route.query.studentId,
                channelCode:this.$store.state.loginUser.channelCode,
                studentName:'',
                sex:'',
                kinshipName:'',
                studentAvatar:'',
                birthday:'',
                height:'',
                weight:'',
                options:{sex:['男','女']},
                columns:[],
                isSet:false,
                isInput:false,
                title:'',
                currentDate:'',
                key:'',
                curText:'',
                details:'',
                minDate: new Date(2000, 0, 1),
                maxDate:new Date(),
                gradeList:[],
                classId:'',
                classIndex:0,
                isChange:false,
            }
        },
        components:{uploadImg},
        created(){
            if(this.studentId){
                this.getDetail();
                if(this.loginUser.channelCode!=='esi'&&this.loginUser.dataManagerStatus==1){//渠道来源且允许修改数据管理
                    this.isChange=true;
                    this.getGrade();
                }
                this.getGrade();
            }
            this.getShip();
           
        },
        methods:{
            getDetail(){
                getStudentInfo({studentId:this.studentId}).then(res=>{
                    let str=res.result;
                    this.studentName=str.studentName;
                    this.sex=this.options.sex[str.gender-1]||'';
                    this.gender=str.gender;
                    this.birthday=str.birthday;
                    this.weight=str.weight?str.weight+'KG':'';
                    this.height=str.height?str.height+'CM':''; 
                    this.kinshipCode=str.parentInfo.kinshipCode;
                    this.kinshipName=str.parentInfo.kinshipName;
                    this.studentAvatar=str.studentAvatar;
                    this.details=str;
                })
            },
            operate(str){
                if(this.channelCode!=='esi'&&str!=='birthday') return;
                this.key=str;
                this.isSet=true;
                if(str=='sex'){
                    this.title='性别';
                }else{
                    this.title='亲属关系';
                }
                this.columns=this.options[str];
            },
            optGrade(str){//修改年级班级
                this.key=str;
                this.isSet=true;
                if(str=='gradeName'){
                    this.title='年级';
                    this.columns=this.gradeList;
                }else{
                    this.title='班级';
                    this.columns=this.gradeList[this.classIndex].classList;
                }
            },
            optInput(str,title){
                if(str=='studentName'&&this.channelCode!=='esi') return;
                let arr=this[str];
                if(arr){
                    arr=str=='studentName'?arr:parseFloat(arr);
                }
                this.key=str;
                this.title=title;
                this.isInput=true;
                this.curText=arr;
            },
            getImg(str){
                this.studentAvatar=str;
            },
            getShip(){
                getKinshipList({type:1}).then(data=>{
                    data.result.forEach(item=>{
                        item.value=item.dictDataCode;
                        item.text=item.dictDataName;
                    }) 
                    this.options.kinshipName=data.result;
                })
            },
            hide(){
                this.isInput=false;
                this.isSet=false;
            },
            saveText(){
                if(this.key=='weight'){
                    this.setWeight();
                }else if(this.key=='height'){
                    this.setHeight();
                }else{
                    this[this.key]=this.curText;
                    this.isInput=false;
                }
                
                
            },
            setHeight(){
                if(parseInt(this.curText)>=30&&parseInt(this.curText)<221){
                    this.height=parseInt(this.curText)+'CM';
                    this.isInput=false;
                }else{
                    this.$toast('身高范围为30-220CM');
                    this.height=''
                }
            },
            setWeight(){
                if(this.curText){
                    let weight=parseFloat(this.curText).toFixed(1);
                    if(weight>=10&&weight<151){
                        this.weight=weight+'KG';
                        this.isInput=false;
                    }else{
                       this.$toast('体重范围为10-150KG');
                    }
                    
                }else{
                    this.$toast('体重范围为10-150KG');
                }
                
            },
            confirm(value,index){
                this.isSet=false;//console.log(value,index);
                if(this.key=='sex'){
                    this.sex=value;
                    this.gender=index+1;
                }else if(this.key=='kinshipName'){
                    this.kinshipCode=value.dictDataCode;
                    this.kinshipName=value.dictDataName;
                }else if(this.key=='gradeName'){
                    this.details.gradeName=value.gradeName;
                    this.classIndex=index;
                    this.details.className=this.details.classId='';
                }else if(this.key=='className'){
                    this.details.className=value.className;
                    this.details.classId=value.classId;
                }else{
                    this.birthday=this.pubMethod.formatDate(value, 'yyyy-MM-dd');
                }
             //   this.submit(value.join(':'));
            },
            handleClick(){
                    
                    if(this.studentName==''||this.gender==''){
                        this.$toast('请完善宝贝信息再提交')
                        return false;
                    }else{
                       if(this.studentId){//编辑
                         updateChild({
                            studentId:this.studentId,
                            parentId:this.details.parentInfo.parentId,
                            studentName:this.studentName,
                            weight:parseFloat(this.weight),
                            height:parseInt(this.height),
                            birthday:this.birthday,
                            studentAvatar:this.studentAvatar,
                            kinshipCode:this.kinshipCode,
                            gender:this.gender,
                            classId:this.details.classId
                        }).then(data=>{
                            // this.loading=false;
                            if(data.code=='00000'){
                               this.$toast('编辑成功');
                               if(this.isChange){
                                    this.getCurUser();
                               } 
                               this.$router.go(-1);
                            }
                        })
                       }else{
                          bindingChild({
                                imei:this.imei,
                                userId:this.loginUser.userId,
                                studentName:this.studentName,
                                weight:parseFloat(this.weight),
                                height:parseInt(this.height),
                                birthday:this.birthday,
                                studentAvatar:this.studentAvatar,
                                kinshipCode:this.kinshipCode,
                                gender:this.gender
                            }).then(data=>{
                                // this.loading=false;
                                if(data.code=='00000'){
                                    this.$toast('绑定成功');
                                    this.onChange(data.result.parentId);
                                }
                            })
                       }
                        // this.loading=true;
                       
                    }

             
            },
            //切换小孩
            onChange(parentId){
                switchUserIdentity({identityId:parentId,userType:5}).then(data=>{
                // console.log(data);
                    if(data.code=='00000'){
                         this.$router.replace({name:'routePage'});
                    
                    }else{
                         this.$toast(data.message)
                    }
                })
            },
            delectCon(){
                let str='删除宝贝信息后，该宝贝的数据无法恢复，请谨慎操作！'
                this.$dialog.confirm({
                    title:'删除宝贝',
                    message: str,
                    confirmButtonColor:'#E84026',
                    confirmButtonText:'删除',
                    cancelButtonColor:'#0A59F7',
                    messageAlign:'left'
                }).then(() => {
                   //删除子女
                    deleteStudent({
                        studentIdList:this.loginUser.studentId
                    }).then((data) => {
                        if (data && data.result) {
                             this.$router.replace({name:'routePage'})
                        }
                    })
                   
                }).catch(() => {
                // on cancel
                });
            },
            getGrade(){
                getGradeClassList({schoolId:this.loginUser.schoolId}).then(res=>{
                    res.result.forEach(item=>{
                        item.value=item.gradeCode;
                        item.text=item.gradeName;
                        item.classList.forEach(obj=>{
                            obj.value=obj.classId;
                            obj.text=obj.className;
                        })
                    })
                    this.gradeList=res.result;
                })
            }
        }
    }
</script>
<style lang="scss" >
    .bindChildren{
        // height:100%;
        padding: 0 .12rem;
        .top{
            padding: .3rem 0rem .18rem;
            text-align: center;
            color:rgba(0,0,0,.9);
            img{
                width: .8rem;
                height: .8rem;
                border-radius: 50%;
                margin-bottom: .2rem;
            }
        }
        .con{
            position: relative;
            background:#fff;
            border-radius: 8px;
            padding:.04rem 0;
            margin-top: .12rem;
            margin-bottom: .06rem;
            .imgs{
                // width: .4rem;
                // height: .4rem;
                // border-radius: 50%;
            }
        }
        .delect{
            color:#E84026;
            margin-top: .2rem;
            text-align: center;
            padding-bottom: .3rem;
        }
        .textPopup{
            width: 80%;
            border-radius: 10px;
            text-align: center;
            .inputCon{
                .title{
                    color:#000;
                    padding-top: .2rem;
                    font-weight: 550;
                }
                .inputs{
                    border: 1px solid #E5E5E5;
                    height: .4rem;
                    line-height: .4rem;
                    padding:0rem .1rem;
                    width: 80%;
                    margin:.1rem auto .2rem;
                    input{
                        border:none;
                    }
                }
                .btn{
                    border-top: 1px solid #eee;
                    display: flex;
                    justify-content: center;
                    line-height: .48rem;
                    color:#0A59F7;
                    p{
                        flex:1;
                        border-right:1px solid #eee;
                    }
                }
            }
        }
        
       
    }
</style>
